import View from '../../reservation/components/ViewReservation';


class ViewReservation extends View {
  renderControls() { // eslint-disable-line class-methods-use-this
    return null;
  }

  renderModals() { // eslint-disable-line class-methods-use-this
    return null;
  }
}

export default ViewReservation;




// WEBPACK FOOTER //
// ./src/app/kiosk/components/ViewReservation.jsx